import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import { CommonCarousel } from '~/components/CommonCarousel';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';

import { userStore } from '~/stores';

import { createCategoryUrl } from '../utils';

import styles from './BannerCategoryBlock.module.scss';

interface Banner {
  src: string;
  scrThumb: string;
  alt: string;
  linkId: number | string;
}

interface BannerCategoryBlockProps {
  banners: Banner[];
  isMobile: boolean;
}

const BannerCategoryBlock = ({
  banners,
  isMobile,
}: BannerCategoryBlockProps) => {
  const { handleClickCategory } = useCategoryAnalytics();

  if (!banners || banners.length === 0) {
    return null;
  }

  return (
    <div className={classes([styles.container, 'banner-carousel carousel'])}>
      <CommonCarousel
        slideClassName="banner-carousel__item"
        containerClassName={styles.carouselContainer}
        sliderClassName={styles.carousel}
        slidesPerViewProp={isMobile ? 1 : 2}
        isAutoplay
        dir={userStore.dir}
        key={userStore.dir}
        loopAdditionalSlides={1}
      >
        {banners.map(({ src, alt, linkId }) => (
          <Link
            data-link={`banner-${linkId}`}
            onClick={handleClickCategory(linkId)}
            to={createCategoryUrl({ id: linkId })}
            key={src}
          >
            <CloudflareResponseImage
              src={src}
              srcSetParams={defaultSrcSetParams}
              alt={alt}
              loading="lazy"
            />
          </Link>
        ))}
      </CommonCarousel>
    </div>
  );
};

export default observer(BannerCategoryBlock);
